import React from 'react';
import { Reveal } from './Reveal';
import { ChartUpIcon, ClockIcon, CrossIcon, YarnIcon } from './icons/CraftIcons';
const painCards = [{
  id: 'hours',
  icon: ClockIcon,
  stat: '10 hrs',
  title: 'Stitched with love',
  body: 'You spend ten hours tejiendo a beautiful piece. It looks amazing.'
}, {
  id: 'freeze',
  icon: CrossIcon,
  stat: '"$20?"',
  title: 'Then you freeze',
  body: 'Someone asks "How much?" and you whisper a scared number instead of a real price.'
}, {
  id: 'rate',
  icon: ChartUpIcon,
  stat: '$2 / hr',
  title: 'That is your wage',
  body: 'Your hands ache, and your yarn stash grows faster than your bank account.'
}];
export function MakersPoverty() {
  return <section aria-labelledby="makers-poverty" className="w-full bg-cream px-4 py-10 sm:px-6 sm:py-14 lg:py-20" data-id="element-259" data-mp="69sw0i0dhc99">
      <div className="mx-auto max-w-[1120px]" data-id="element-260" data-mp="f9peg1w65evv">
        <Reveal className="mx-auto max-w-2xl text-center" data-id="element-261" data-mp="fb0hfzhsiilx">
          <span className="inline-flex items-center gap-2 rounded-full border border-hairline bg-ivory px-3 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.14em] text-ink-soft" data-id="element-262" data-mp="1pn1gm58up1cm">
            <YarnIcon className="h-3.5 w-3.5 text-sage" data-id="element-263" data-mp="1unpfte78gohx" />
            Section 2 — The maker&rsquo;s poverty
          </span>
          <h2 id="makers-poverty" className="mt-4 font-display text-3xl font-bold leading-tight text-ink sm:text-[38px]" data-id="element-264" data-mp="23n2j1p4rkgu7">
            You don&rsquo;t have a pricing problem. You have a{' '}
            <em className="italic text-crimson" data-id="element-265" data-mp="2djfmheq42925">system</em> problem.
          </h2>
        </Reveal>

        <div className="mt-7 grid gap-4 sm:mt-10 sm:grid-cols-3 sm:gap-5" data-id="element-266" data-mp="2icrx2kxygfbw">
          {painCards.map((card, index) => {
          const Icon = card.icon;
          return <Reveal key={card.id} delay={index * 0.1} data-id="element-267" data-mp="2rcwty15ivvbt" data-mpi={index}>
                <div className="group h-full rounded-2xl border border-hairline bg-ivory p-6 shadow-soft transition-transform duration-300 hover:-translate-y-1.5" data-id="element-268" data-mp="2raam00epzdt2">
                  <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-linen text-sage-dark" data-id="element-269" data-mp="w9s41z71vaxz">
                    <Icon className="h-5 w-5" data-id="element-270" data-mp="s984yq2x1x97" />
                  </span>
                  <p className="mt-4 font-display text-3xl font-extrabold text-ink" data-id="element-271" data-mp="15ztp0i43wd8o">{card.stat}</p>
                  <h3 className="mt-1 text-sm font-extrabold uppercase tracking-wide text-ink-soft" data-id="element-272" data-mp="1170l1wggp8xn">
                    {card.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-ink-soft" data-id="element-273" data-mp="1axv8v59cwgl7">{card.body}</p>
                </div>
              </Reveal>;
        })}
        </div>

        <Reveal delay={0.2} data-id="element-274" data-mp="1owuvk7db6leq">
          <div className="mx-auto mt-7 max-w-2xl rounded-2xl border-l-4 border-l-crimson border-y border-r border-hairline bg-ivory px-5 py-5 text-center shadow-soft sm:mt-10 sm:px-6" data-id="element-275" data-mp="1jyjm3xqxecx1">
            <p className="text-sm leading-relaxed text-ink sm:text-base" data-id="element-276" data-mp="3qqu6grmir0qw">
              You have a <strong className="font-extrabold" data-id="element-277" data-mp="3ls0ux4qsljtd">hobby draining your wallet</strong> —
              instead of a <strong className="font-extrabold text-sage-dark" data-id="element-278" data-mp="219yon41f6z2v">business fueling your freedom</strong>.
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}